import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrendex = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.30648 8.13C6.71304 9.12655 4.58736 8.932 3.20173 7.54637C1.58977 5.93441 1.58977 3.32092 3.20173 1.70897C4.81368 0.0970114 7.42718 0.0970114 9.03913 1.70897C10.4055 3.07536 10.6137 5.16139 9.66359 6.74704C9.69011 6.7685 9.71577 6.79156 9.74043 6.81622L11.5282 8.60403L10.1518 9.98048L8.36398 8.19267C8.34373 8.17243 8.32457 8.15152 8.30648 8.13ZM8.22383 6.74704C7.0362 7.93466 5.15311 7.90015 4 6.74704C2.84689 5.59393 2.83645 3.66355 4 2.5C5.16355 1.33645 7.06374 1.33992 8.22383 2.5C9.38391 3.66008 9.41145 5.55942 8.22383 6.74704Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9649 12.7936L14.3413 11.4171L19.3744 16.4502C19.7545 16.8303 19.7545 17.4466 19.3744 17.8267C18.9943 18.2068 18.3781 18.2068 17.998 17.8267L12.9649 12.7936Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 9.00797V2.75797H14.25V4.47047H17.5375L8 13.383L5.5 10.883L0.5 15.5002V19.5002L5.5 14.008L8 16.508L18.825 5.68297V9.00797H20.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgTrendex;
